import React from "react";
import styled from "styled-components";
import ReactGA from "react-ga4";

// assets
import AdBannerImage from "assets/image/SAMSUNG.png";

const AdBanner = () => {
  const EVENT_ON = new Date("2024-09-01T00:00:00").getTime();
  const EVENT_OFF = new Date("2024-09-30T23:59:59").getTime();
  const currentDate = new Date().getTime();

  const isEventTime = currentDate > EVENT_ON && currentDate < EVENT_OFF;

  const link =
    "https://crm-guide.bodycodi.com/6e976b88-45d1-46e6-95c0-96b2089444d0";

  const handleClick = (targetUrl) => {
    ReactGA?.event({
      category: "Banners",
      action: "banner_click",
      label: "Banner clicked",
      value: 1,
    });

    if (window.ReactNativeWebView) {
      const data = JSON.stringify({
        type: "openExternalLink",
        link: targetUrl,
      });
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.location.href = targetUrl;
    }
  };

  if (!isEventTime) return null;

  return (
    <Wrapper onClick={() => handleClick(link)}>
      <div>
        <span>바디코디 9월 특별 기획전</span>
        <span>최고의 가성비, 기능성 고급 헤드폰 피아톤</span>
      </div>

      <img src={AdBannerImage} alt="ad_banner_image" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 70px;
  background-color: ${(props) =>
    `${props.isSpoexBanner ? "#F7DAED" : "#f8e8e8"}`};
  border-radius: 8px;
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 20px;

  > div {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    > span:first-child {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      color: #3c3f44;
      letter-spacing: -0.4px;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > span:first-child + span {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #c6718a;
      letter-spacing: -0.2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  img {
    width: 100px;
    height: auto;
  }
`;

export default AdBanner;
